import classNames from "classnames";
import React, { useState } from "react";
import Calendar from "react-calendar";
import Popup from "reactjs-popup";

import { useMainStore } from "@/contexts/Store";

import arrowLeft from "../../../../images/table-image/icon/arrow-left.svg";
import arrowRight from "../../../../images/table-image/icon/arrow-right.svg";
import {
  formatDate,
  formatDateForCellValue,
} from "../../../helpers/DateFormatters";

type Props = {
  attachedDocumentID?: number;
  fieldName?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialValue?: any;
  recordID?: number;
};

function AttachmentDocumentDateSelect({
  initialValue,
  attachedDocumentID,
  recordID,
  fieldName,
}: Props) {
  // Import MobX stores
  const mainStore = useMainStore();

  // State
  const [date, setDate] = useState(
    fieldName == "upload_date" ? initialValue || new Date() : initialValue,
  );
  const [activeStartDate, setActiveStartDate] = useState(null);
  const [dateString, setDateString] = useState(formatDate(date));
  const [showPopup, setShowPopup] = useState(false);

  // @ts-expect-error TS(7006) FIXME: Parameter 'newDate' implicitly has an 'any' type.
  const onCalendarChange = (newDate) => {
    // Set date
    setDate(newDate);
    setDateString(formatDate(newDate));

    // Persist changes
    persistDate(newDate);

    // Close popup
    onClose();
  };

  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const onInputChange = (event) => {
    const newDateString = event.target.value;

    // Set dateString without any conditions, since it defines the value in input
    setDateString(newDateString);

    // Try to parse a date
    if (newDateString !== null && newDateString !== "") {
      const dateParts = newDateString.split("/");
      const month = Number(dateParts[0]);
      const day = Number(dateParts[1]);
      const year = Number(dateParts[2]);

      if (year >= 2000 && month >= 1 && month <= 12 && day >= 1 && day <= 31) {
        const newDate = new Date(year, month - 1, day);

        // @ts-expect-error TS(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
        if (!isNaN(newDate)) {
          setDate(newDate);
          setActiveStartDate(
            // @ts-expect-error TS(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
            new Date(newDate.getFullYear(), newDate.getMonth(), 1),
          );
          persistDate(newDate);
        }
      }
    }
  };

  // @ts-expect-error TS(7006) FIXME: Parameter 'value' implicitly has an 'any' type.
  const onActiveStartDateChange = (value) => {
    setActiveStartDate(value.activeStartDate);
  };

  const setToday = () => {
    const today = new Date();
    // @ts-expect-error TS(2345) FIXME: Argument of type 'Date' is not assignable to param... Remove this comment to see the full error message
    setActiveStartDate(new Date(today.getFullYear(), today.getMonth(), 1));
    onCalendarChange(today);
  };

  const onOpen = () => {
    setShowPopup(true);
  };

  const onClose = () => {
    setShowPopup(false);
  };

  // @ts-expect-error TS(7006) FIXME: Parameter 'newDate' implicitly has an 'any' type.
  const persistDate = (newDate) => {
    if (newDate) {
      const attachedDocumentParams = {
        // @ts-expect-error TS(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
        [fieldName]: formatDateForCellValue(newDate),
        extras: {
          // @ts-expect-error TS(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
          [fieldName]: formatDateForCellValue(newDate),
        },
      };
      mainStore.attachedDocuments.update(
        attachedDocumentID,
        recordID,
        attachedDocumentParams,
      );
    }
  };

  const triggerClasses = classNames(
    "set-date-button",
    "attached-document-date-button",
    {
      active: showPopup,
      illumination: initialValue,
    },
  );

  const modalTrigger = (
    <div
      className={triggerClasses}
      // @ts-expect-error TS(2322) FIXME: Type 'string' is not assignable to type 'number'.
      tabIndex="0"
    >
      <div className="cell-content">{dateString}</div>
    </div>
  );

  const popup = (
    <Popup
      trigger={modalTrigger}
      position="bottom left"
      open={showPopup}
      onOpen={onOpen}
      onClose={onClose}
      keepTooltipInside
    >
      <div
        className="select-small-wrap calendar-wrap"
        data-testid="date-cell-popup"
      >
        <input
          className="input-date"
          data-testid="date-cell-input"
          // @ts-expect-error TS(2322) FIXME: Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
          value={dateString}
          onChange={onInputChange}
        />
        <Calendar
          // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'Date | unde... Remove this comment to see the full error message
          activeStartDate={activeStartDate}
          onActiveStartDateChange={onActiveStartDateChange}
          formatShortWeekday={(_, weekday) =>
            ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"][weekday.getDay()]
          }
          value={date}
          onChange={onCalendarChange}
          prevLabel={<img src={arrowLeft} alt="image" />}
          nextLabel={<img src={arrowRight} alt="image" />}
        />
        <button
          className="table-button set-today"
          data-testid="date-cell-set-today"
          onClick={setToday}
        >
          Set Today
        </button>
      </div>
    </Popup>
  );

  return popup;
}

AttachmentDocumentDateSelect.defaultProps = {
  fieldName: "upload_date",
};

export default AttachmentDocumentDateSelect;
